export default __webpack_public_path__ + "static/media/img_logo_acca.ed757ac6.svg";